import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27fa22c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-data" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 属性 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 子设备 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 告警记录 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 发货记录 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 出厂测试 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 升级记录 ", -1))

import { ref } from 'vue'
import DeviceInfo from './components/device-info.vue'
import DeviceVarTable from './components/device-var-table.vue'
import DeviceMap from './components/device-map.vue'
import { isEmpty } from 'lodash'
import { queryDeviceInfo } from '@/api'
import { useRouter, useRoute } from 'vue-router'
import { CODE_ENUM } from '@/common'
import VarList from './components/var-list.vue'
import SubDeviceTable from './components/sub-device-table.vue'
import RecordTable from './components/record-table.vue'
import WarningTable from './components/warning-table.vue'
import FactoryTestTable from './components/factory-testing.vue'
import UpgradeTable from './components/upgrade-table.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeName = ref('first')

const router = useRouter()
const $route = useRoute()
const deviceId = $route.query.deviceId || ''

const deviceMapRef = ref()

const deviceData: any = ref({})
const queryDetail = async () => {
  const res: any = await queryDeviceInfo({
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceData.value = res.data

    const data = res.data
    setTimeout(() => {
      if (!isEmpty(data.deviceLocationInfo)) {
        deviceMapRef.value.createMaker(data.deviceLocationInfo)
      }
    }, 500)
  }
}

queryDetail()

const toStatisticsHistory = (query: any) => {
  console.log(query)
  router.push({
    name: 'statistics-history',
    query: {
      ...query,
      orgId: deviceData.value.topOrgId,
    },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DeviceInfo, { data: deviceData.value }, null, 8, ["data"]),
      _createVNode(DeviceMap, {
        ref_key: "deviceMapRef",
        ref: deviceMapRef
      }, null, 512)
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      class: "tabs ws_mt16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { name: "first" }, {
          label: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(VarList, { onOnData: toStatisticsHistory })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "first1" }, {
          label: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(SubDeviceTable, { data: deviceData.value }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "first2" }, {
          label: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode(WarningTable)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "firs3t" }, {
          label: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(RecordTable)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "firs4" }, {
          label: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createVNode(FactoryTestTable)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "firs5" }, {
          label: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _createVNode(UpgradeTable, { data: deviceData.value }, null, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})